import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/customers')({
  staticData: { crumb: 'customers' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'customers.read'),
  component: Outlet,
})
